var _g, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSilver(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_368_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4 8C4 3.58172 7.58172 0 12 0H60C64.4183 0 68 3.58172 68 8V56C68 60.4183 64.4183 64 60 64H12C7.58172 64 4 60.4183 4 56V8Z",
    fill: "url(#paint0_linear_368_13)"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_d_368_13)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M54.9664 45.6998L38.6894 55.1781C37.1514 56.0747 35.2609 56.0747 33.7229 55.1781L17.4458 45.6998C15.9292 44.8139 15 43.1915 15 41.4303V22.4096C15 20.6591 15.9292 19.0367 17.4458 18.1508L33.7229 8.67245C35.2609 7.77585 37.1514 7.77585 38.6894 8.67245L54.9664 18.1508C56.4831 19.0367 57.4123 20.6591 57.4123 22.4096V41.441C57.4123 43.1915 56.4831 44.8139 54.9664 45.6998Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M54.678 43.864L37.3222 53.7692C36.6279 54.1642 35.7628 54.1642 35.0579 53.7692L17.7234 43.864C17.0292 43.469 16.5913 42.7219 16.5913 41.932V22.1215C16.5913 21.3209 17.0185 20.5844 17.7234 20.1895L35.0793 10.2842C35.7735 9.8893 36.6386 9.8893 37.3435 10.2842L54.6993 20.1895C55.3936 20.5844 55.8315 21.3316 55.8315 22.1215V41.932C55.8101 42.7325 55.3829 43.469 54.678 43.864Z",
    fill: "#C7C7D7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.2756 56.0001C35.4425 56.0001 34.6094 55.7866 33.8618 55.349L17.5527 45.8173C16.0894 44.9634 15.1923 43.3837 15.1923 41.6972V22.5271C15.1923 20.8407 16.1001 19.261 17.5527 18.4071L33.8618 8.86469C35.3464 7.98944 37.1941 7.98944 38.6894 8.86469L55.0092 18.4071C56.4724 19.261 57.3696 20.8407 57.3696 22.5271V41.6866C57.3696 43.373 56.4617 44.9528 55.0092 45.8067L38.6894 55.349C37.9417 55.7866 37.1087 56.0001 36.2756 56.0001ZM36.2756 10.5618C35.8484 10.5618 35.4318 10.6686 35.0473 10.8927L18.7382 20.4351C18.0012 20.8727 17.5313 21.6732 17.5313 22.5271V41.6866C17.5313 42.5405 17.9906 43.3517 18.7382 43.7786L35.058 53.321C35.8163 53.7586 36.7562 53.7586 37.5145 53.321L53.8343 43.7786C54.5713 43.341 55.0412 42.5405 55.0412 41.6866V22.5271C55.0412 21.6732 54.582 20.862 53.8343 20.4351L37.5038 10.8927C37.1193 10.6686 36.7028 10.5618 36.2756 10.5618Z",
    fill: "url(#paint1_linear_368_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.5994 43.0633L37.3971 52.3068C36.7456 52.6804 35.9445 52.6804 35.2823 52.3068L19.0907 43.0633C18.4392 42.6898 18.0333 42.0066 18.0333 41.2595V22.7618C18.0333 22.0146 18.4392 21.3315 19.0907 20.9579L35.293 11.7038C35.9445 11.3302 36.7456 11.3302 37.4078 11.7038L53.6101 20.9473C54.2616 21.3208 54.6674 22.004 54.6674 22.7511V41.2488C54.6568 42.0066 54.2509 42.6898 53.5994 43.0633Z",
    fill: "#FEEBFF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M53.7169 42.8713L36.7883 52.7232C36.5212 52.8833 36.1901 52.8833 35.9231 52.7232L19.0052 42.8713C18.7382 42.7219 18.578 42.4337 18.578 42.1348V22.4096C18.578 22.1108 18.7382 21.8226 19.0052 21.6732L35.9338 11.8213C36.2008 11.6611 36.5319 11.6611 36.7989 11.8213L53.7275 21.6732C53.9945 21.8226 54.1548 22.1108 54.1548 22.4096V42.1348C54.1441 42.4443 53.9839 42.7219 53.7169 42.8713Z",
    fill: "url(#paint2_linear_368_13)"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.39
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.3716 52.0081C36.1474 52.0081 35.9337 51.9547 35.7308 51.8373L19.8809 42.5191C19.4964 42.2949 19.2615 41.8786 19.2615 41.441V22.7726C19.2615 22.335 19.4964 21.9187 19.8809 21.6945L35.7308 12.3763C36.126 12.1415 36.6066 12.1415 37.0018 12.3763L52.8517 21.6945C53.2362 21.9187 53.4711 22.335 53.4711 22.7726V41.4303C53.4711 41.868 53.2362 42.2842 52.8517 42.5084L37.0018 51.8266C36.8095 51.9547 36.5959 52.0081 36.3716 52.0081ZM20.7567 41.3023L36.3716 50.4817L51.9865 41.3023V22.9113L36.3716 13.7319L20.7567 22.9113V41.3023Z",
    fill: "url(#paint3_linear_368_13)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M36.3182 53.449C36.0192 53.449 35.7308 53.3743 35.4638 53.2142L18.7381 43.405C18.2254 43.1061 17.905 42.5404 17.905 41.9534V22.2922C17.905 21.6945 18.2254 21.1395 18.7381 20.8406L35.4638 11.0207C35.9871 10.7112 36.6493 10.7112 37.1727 11.0207L53.8983 20.8406C54.411 21.1395 54.7314 21.6945 54.7314 22.2922V41.9534C54.7314 42.5511 54.411 43.1061 53.8983 43.405L37.1727 53.2249C36.9163 53.3743 36.6173 53.449 36.3182 53.449ZM19.6139 41.9427L36.3289 51.7519L53.0332 41.9427V22.3029L36.3182 12.4937L19.6139 22.3029V41.9427Z",
    fill: "url(#paint4_linear_368_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30.1984 31.0767L36.4678 23.2314L42.4382 31.1194L36.3824 38.8792L30.1984 31.0767Z",
    fill: "#BABAC6"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.8875 31.1621L30.1557 31.1194L36.4251 23.2741L36.4892 19.1541L26.8875 31.1621Z",
    fill: "url(#paint5_linear_368_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.3824 38.89L30.1557 31.1301L26.8875 31.1728L36.4679 43.2662L36.3824 38.89Z",
    fill: "url(#paint6_linear_368_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.4489 31.0981L45.9308 31.2262L36.4785 43.2449L36.3931 38.8687L42.4489 31.0981Z",
    fill: "url(#paint7_linear_368_13)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M36.4893 19.1541L45.9308 31.2261L42.449 31.098L36.4252 23.2741L36.4893 19.1541Z",
    fill: "url(#paint8_linear_368_13)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_368_13",
    x: 0,
    y: 0,
    width: 72,
    height: 72,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_d_368_13",
    x: 11,
    y: 8,
    width: 50.4122,
    height: 56,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_368_13"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_368_13",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_368_13",
    x1: 36,
    y1: 0,
    x2: 36,
    y2: 64,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DED7FF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_368_13",
    x1: 25.6017,
    y1: 13.6322,
    x2: 46.9302,
    y2: 50.5975,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#DEDAF1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3128,
    stopColor: "#C7C4E3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6369,
    stopColor: "#AAA7C8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8A88A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_368_13",
    x1: 34.284,
    y1: 15.3295,
    x2: 39.2727,
    y2: 56.0149,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#D9D6E6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2658,
    stopColor: "#B5B4CB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6677,
    stopColor: "#9294B8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8618,
    stopColor: "#6B6B8C"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_368_13",
    x1: 19.2631,
    y1: 32.1067,
    x2: 53.4807,
    y2: 32.1067,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7872A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B1ADC2"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_368_13",
    x1: 26.9668,
    y1: 15.9245,
    x2: 45.6624,
    y2: 48.3266,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#79788A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2291,
    stopColor: "#9290A9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4497,
    stopColor: "#9493A7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7961,
    stopColor: "#B4B1CA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CECCDE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_368_13",
    x1: 35.3582,
    y1: 22.9103,
    x2: 28.8234,
    y2: 30.0623,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F4F4F4"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E4E4E4"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_368_13",
    x1: 33.2869,
    y1: 35.4582,
    x2: 31.286,
    y2: 37.648,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#817AA8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A0A0B3"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_368_13",
    x1: 42.9952,
    y1: 33.3053,
    x2: 36.5001,
    y2: 40.4137,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A9A6BE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#5E5C82"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint8_linear_368_13",
    x1: 41.3223,
    y1: 25.0675,
    x2: 39.2793,
    y2: 27.3034,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A29EBE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#605F7C"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSilver);
export default __webpack_public_path__ + "static/media/silver.fbfed30f55e34e31f28aa7a62f21f488.svg";
export { ForwardRef as ReactComponent };